import React from 'react';
import {Container, Row, Col, Card, Accordion} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const Faq = () => {
    const { t } = useTranslation();
    
    return (
        <>  
            <div id='content-page' className='content-page'>
            <Container id="faqAccordion">
                <Row>
                <Col sm="12">
                        <Card className="position-relative inner-page-bg bg-primary" style={{height: "150px"}}>
                            <div className="inner-page-title">
                                <h3 className="text-white">{t("FAQ")}</h3>
                                <p className="text-white">{t("Questions fréquemment posées")}</p>
                            </div>
                        </Card>
                    </Col>
                    <Col lg="12">
                        <Accordion id="accordionExample" defaultActiveKey="0">
                            <Accordion.Item className="mb-3" eventKey="0">
                                <Accordion.Header id="heading1">
                                    <strong>🔹 {t("À propos de SEEKS")}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <h5>{t("Qu'est-ce que SEEKS ?")}</h5>
                                    <p>{t("SEEKS est une plateforme BtoB qui facilite la mise en relation professionnelle entre entreprises, grâce à un système intelligent de mots-hameçons. Elle permet de publier des demandes, de recevoir des offres ciblées, et de développer son réseau d'affaires.")}</p>
                                    
                                    <h5>{t("À qui s'adresse SEEKS ?")}</h5>
                                    <p>{t("SEEKS est réservée aux professionnels (entreprises, indépendants, associations...) disposant d'un numéro SIRET ou d'un extrait KBIS valide.")}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item className="mb-3" eventKey="1">
                                <Accordion.Header id="heading2">
                                    <strong>🔹 {t("Fonctionnement")}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <h5>{t("Comment fonctionne la mise en relation ?")}</h5>
                                    <p>{t("Les utilisateurs publient leurs besoins. SEEKS les analyse automatiquement et les fait correspondre à d'autres professionnels ayant indiqué des \"mots-hameçons\" liés à leur offre.")}</p>
                                    
                                    <h5>{t("C'est quoi un mot-hameçon ?")}</h5>
                                    <p>{t("C'est un mot-clé que vous choisissez pour signaler les services que vous proposez. Par exemple : \"tablette\", \"formation RH\", \"transport urgent\". Le système les utilise pour vous connecter aux demandes pertinentes.")}</p>
                                    
                                    <h5>{t("Puis-je tester SEEKS gratuitement ?")}</h5>
                                    <p>{t("Oui. Une version d'accès limitée est disponible pour tester la plateforme avec des fonctionnalités de base et un nombre restreint de mots-hameçons.")}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            
                            <Accordion.Item className="mb-3" eventKey="2">
                                <Accordion.Header id="heading3">
                                    <strong>🔹 {t("Abonnements et tarifs")}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <h5>{t("Quels sont les types d'abonnements ?")}</h5>
                                    <p>{t("SEEKS propose plusieurs formules :")}</p>
                                    <ul>
                                        <li>{t("Essentiel : 10 mots-hameçons")}</li>
                                        <li>{t("Avancé : mots illimités + options de visibilité")}</li>
                                        <li>{t("International : accès aux connexions étrangères")}</li>
                                        <li>{t("IA : système prédictif intelligent pour capter vos futurs leads")}</li>
                                    </ul>
                                    
                                    <h5>{t("Puis-je résilier mon abonnement ?")}</h5>
                                    <p>{t("Oui. Vous pouvez résilier à tout moment depuis votre tableau de bord. En cas d'abonnement annuel, un remboursement au prorata est possible (hors offres spéciales).")}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            
                            <Accordion.Item className="mb-3" eventKey="3">
                                <Accordion.Header id="heading4">
                                    <strong>🔹 {t("Compte utilisateur")}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <h5>{t("Comment créer un compte ?")}</h5>
                                    <p>{t("Cliquez sur \"Inscription\" et remplissez les informations demandées (email, SIRET, secteur d'activité). Vous recevrez un email de confirmation.")}</p>
                                    
                                    <h5>{t("Puis-je modifier mes mots-hameçons ?")}</h5>
                                    <p>{t("Oui, à tout moment via votre espace personnel, sauf dans la formule gratuite où leur nombre est limité.")}</p>
                                    
                                    <h5>{t("Que se passe-t-il si je fournis de fausses informations ?")}</h5>
                                    <p>{t("Le compte peut être suspendu ou supprimé conformément à nos CGU.")}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            
                            <Accordion.Item className="mb-3" eventKey="4">
                                <Accordion.Header id="heading5">
                                    <strong>🔹 {t("Sécurité & confidentialité")}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <h5>{t("Mes données sont-elles protégées ?")}</h5>
                                    <p>{t("Oui. SEEKS respecte le RGPD. Vos données ne sont jamais revendues sans votre consentement explicite. Vous pouvez à tout moment demander leur suppression.")}</p>
                                    
                                    <h5>{t("Puis-je supprimer mon compte ?")}</h5>
                                    <p>{t("Oui, sur simple demande via l'interface ou par email à contact@seeks.biz.")}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            
                            <Accordion.Item className="mb-3" eventKey="5">
                                <Accordion.Header id="heading6">
                                    <strong>🔹 {t("Assistance")}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <h5>{t("J'ai un problème technique, que faire ?")}</h5>
                                    <p>{t("Contactez notre support à l'adresse contact@seeks.biz (ou formulaire sur le site). Nous répondons sous 48h ouvrées.")}</p>
                                    
                                    <h5>{t("Puis-je signaler un comportement abusif ?")}</h5>
                                    <p>{t("Oui. Chaque fiche utilisateur contient un bouton de signalement. Nous traitons tous les signalements sous 48h.")}</p>
                                </Accordion.Body>
                            </Accordion.Item>                
                        </Accordion>
                    </Col>
                </Row>
                </Container>
                </div>
        </>
    )
}

export default Faq